import {createContext, useContext} from "react";
import UserStore from "../stores/UserStore";

export const UserContext = createContext(new UserStore() );
export const UserContextProvider = UserContext.Provider;
export const useUserContext = () => {
    return useContext(UserContext)
}